module.exports = __webpack_public_path__ + "assets/img/w2.0fd0dfd7.jpg";